module.exports = __webpack_public_path__ + "static/assets/9c262b77327fabcebef49598da1a4c9f.png";